export default __webpack_public_path__ + "0cfbdfdcc447d8763803ecafcf235c8b.png";